import * as React from 'react';
import * as style from './style.css';
import { Image } from '@cian/ui-kit';
import { jsx as _jsx } from "react/jsx-runtime";
export const LayoutImage = _ref => {
  let {
    url
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: style['image'],
    children: /*#__PURE__*/_jsx(Image, {
      src: url,
      alt: "\u041F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u043A\u0430 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u044B",
      objectFit: "contain"
    })
  });
};